import idGenerator from '@/lib/helpers/id-generator';
import modelStore from '@/lib/services/models-store';
import FormException from '@/lib/exceptions/form-exception';
import {
  ADD_MODEL_OF_TYPE,
  UPDATE_MODEL_OF_TYPE,
} from '@/lib/constants/mutations';

import {
  MODEL_TO_STATE,
} from '@/lib/constants/model-types';

import store from '@/store';

import getModelPropertyFromStore from '@/lib/helpers/get-model-property-from-store';

const isNewPropertyValue = (model, propertyName) => {
  const { $modelType } = model.constructor;
  const oldValue = getModelPropertyFromStore(
    $modelType,
    model.id,
    propertyName,
  );
  if (oldValue === undefined) {
    return true;
  }
  const modelData = model.$modelData;
  return JSON.stringify(modelData[propertyName]) !== JSON.stringify(oldValue);
};

class BaseModel {
  constructor() {
    this.__id = idGenerator();
    modelStore.addInstance(this);

    this.$modelData = {};
    this.$saveModelToStore();
  }

  static get $mutationToCommit() {
    return ADD_MODEL_OF_TYPE;
  }

  get id() {
    return this.__id;
  }

  get $modelStore() {
    const { state } = store;
    const stateName = MODEL_TO_STATE[this.constructor.$modelType];

    return state[stateName][this.id];
  }

  static get $modelType() {
    throw new FormException('Needs to implement modelType on children');
  }

  $saveModelToStore() {
    const plainData = this.$modelData;

    if (plainData) {
      const {
        $mutationToCommit,
        $modelType,
      } = this.constructor;

      store.commit(
        $mutationToCommit,
        {
          modelType: $modelType,
          plainData,
          modelId: this.id,
        },
      );
    }
  }

  $updateModelToStore(propertyName) {
    const modelData = this.$modelData;
    const property = {
      [propertyName]: modelData[propertyName],
    };
    const { $modelType } = this.constructor;
    if (isNewPropertyValue(this, propertyName)) {
      store.commit(UPDATE_MODEL_OF_TYPE, {
        modelType: $modelType,
        modelId: this.id,
        newProperties: property,
      });
    }
  }
}

export default BaseModel;
